<template>
  <div class="navbar">
    <div class="left-title">
      <img
        class="logo"
        src="../../assets/ZoomLogo.png"
        @click="onLogoClicked"
        style="margin-right: 12px"
      />
      {{ `Search & ES Manage` }}
    </div>
    <div class="right-menu">
      <zm-dropdown>
        <zm-avatar size="small" class="mgr-md">
          <div style="font-size: 21px; line-height: 36px">
            {{ username.charAt(0).toLocaleUpperCase() }}
          </div>
        </zm-avatar>
        <zm-dropdown-menu
          slot="dropdown"
          :hide-timeout="350"
          class="user-center-popver"
        >
          <zm-dropdown-item class="user-name">
            Hi, {{ username }}
          </zm-dropdown-item>
          <zm-dropdown-item>
            <span @click="logout()">Log Out</span>
          </zm-dropdown-item>
        </zm-dropdown-menu>
      </zm-dropdown>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      username: localStorage.email
    }
  },
  methods: {
    logout() {
      localStorage.setItem('token', '')
      this.$router.push({ path: '/search/index/config' })
    },
    onLogoClicked() {
      this.$router.push({ path: '/login' })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import '@/styles/common.scss';
.navbar {
  box-sizing: border-box;
  height: $search-navbar-height;
  width: 100%;
  background-color: #fff;
  z-index: 99;
  border-radius: 0px !important;
  border-bottom: 1px solid $divider-color;
  box-shadow: 0 2px 4px 0 $divider-color;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left-title {
    display: flex;
    align-items: center;
    .logo {
      height: 27px;
      padding-left: 20px;
    }
  }
  .right-menu {
    height: 100%;
    line-height: $search-navbar-height;
    display: flex;
    align-items: center;
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }
    ::v-deep {
      .zm-avatar--small {
        display: block;
        background-color: #0e71ebcf;
        width: 36px;
        height: 36px;
      }
    }
  }
}
</style>
<style lang="scss">
.user-center-popver.zm-popper.zm-dropdown-menu {
  padding: 8px 12px;
  .zm-dropdown-menu__item {
    color: #0e71eb;
  }
  .user-name.zm-dropdown-menu__item {
    border-bottom: 1px solid #e8e9eb;
    color: #333;
    font-weight: bold;
  }
}
</style>
